
class Autocomplete {

    defaultOptions() {
        return {
            '$container' : null,

            'listClass': '',
            'listItemClass': '',
            'showNoItemMessage': false,
            'messageNoItem': window.translate('app.autocomplete.message.noItem'),

            'items': [],
            'onClickDispose': true,
            'renderItem': function(item,index){ return 'ITEM'; },
            'onClickItem': function(item,index){ return; },
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(!this.$container){
            window.notify('app/list/Autocomplete.$container must be defined','error');
        }

        this.items = this.settings.items;

        this.initialize();
    }

    initialize() {

        this.$container
        .html('')
        .append(
            this.buildList()
        );
    }

    buildList(){
        this.$list = $('<ul/>')
        .addClass('list-group autocomplete-list')
        .addClass(this.settings.listClass);

        if(this.items.length <= 0 && this.settings.showNoItemMessage){
            return $('<div/>')
            .addClass('alert alert-warning')
            .append(this.settings.messageNoItem);
        }


        for(var i in this.items){
            let item = this.items[i];
            let $item = this.buildListItem(item,i);
            this.$list.append($item);
        }


        return this.$list;
    }

    buildListItem(item,index){
        var self = this;
        let $item = $('<li/>')
        .attr('data-index',index)
        .addClass('list-group-item autocomplete-list-item')
        .addClass(this.settings.listItemClass)
        .data('item',item)
        .on('click',function(event){
            self.onClickItem(item,index);
        });

        $item.append(this.settings.renderItem(item,index));

        return $item;
    }


    onClickItem(item){
        if(this.settings.onClickDispose){
            this.$container.html('');
        }
        this.settings.onClickItem(item);
    }
}

module.exports = Autocomplete;

